import React from "react";

const portfolioItems = [
  {
    id: 1,
    image: "assets/imgs/portfolio/masonary/portfolio-masonary-01.png",
    tag: "CRM Web Portal",
    title: "For Staff Management System",
    link: "https://avatarglobalservices.com/avatarconsole",
  },
  {
    id: 2,
    image: "assets/imgs/portfolio/masonary/portfolio-masonary-04.png",
    tag: "HOSTIA",
    title: "Membership Portal Website",
    link: "https://www.hostiahosur.com/",
  },
  {
    id: 3,
    image: "assets/imgs/portfolio/masonary/portfolio-masonary-03.png",
    tag: "Laravel Website",
    title: "Kanmani Motobikes",
    link: "https://kanmanimotobikes.com/",
  },
  {
    id: 4,
    image: "assets/imgs/portfolio/masonary/portfolio-masonary-02.png",
    tag: "Shopify",
    title: "Shopify Website",
    link: "https://www.trusnax.com/",
  },
  {
    id: 5,
    image: "assets/imgs/portfolio/masonary/06.png",
    tag: "Laravel E-commerce",
    title: "Deztyle",
    link: "#",
  },
  {
    id: 6,
    image: "assets/imgs/portfolio/masonary/07.png",
    tag: "PHP E-commerce",
    title: "Divazconsulting.com",
    link: "https://divazconsultancy.com/",
  },
];

const Works = () => {
  return (
    <section id="homeworks" className="bd-portfolio__area section-space">
      <div className="container">
        <div className="row g-5 align-items-end section__title-space">
          <div className="col-lg-12 col-md-12">
            <div className="section__title-wrapper text-center">
              <h4 className="section__title">Some Of My Works</h4>
            </div>
          </div>
        </div>
        <div className="portfolio__wrapper">
          <div className="row grid g-5 wow fadeInUp" data-wow-delay=".5s">
            {portfolioItems.map((item) => (
              <div className="col-xl-4 col-lg-4 col-md-6 grid-item" key={item.id}>
                <div className="portfolio__item">
                  <div className="portfolio__thumb">
                    <img src={item.image} alt={item.title} />
                  </div>
                  <div className="portfolio__content">
                    <div className="portfolio__info">
                      <div className="portfolio__tag">{item.tag}</div>
                      <h5 className="portfolio__title">
                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                          {item.title}
                        </a>
                      </h5>
                    </div>
                    <div className="portfolio__btn">
                      <a href={item.link} target="_blank" rel="noopener noreferrer" className="circle-btn">
                        <span className="icon__box">
                          <i className="fa-regular fa-arrow-right-long"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Works;
